export enum AddressTypeEnum {
        Hospital = 74,
        Practice = 75,
        AhtProvider = 76,
        Provider = 77,
}
